import { useQuery } from "@tanstack/react-query";
import { Bento } from "@/components/ui/box";
import { BentoVisit } from "@/components/ui/box-visit-context";
import { regradeKeys, regradesApi } from "@/lib/api/regrades";
import { useRegradeRequestBoxes } from "./regrade-request-boxes";

/**
 * The learner's one reasoned regrade request for one released attempt (S6, #1293),
 * beside its released result in hand-in and quiz feedback. Practice, completion,
 * legacy and zero-day terms draw nothing: no request is offered and none is guessed.
 */
export function RegradeRequest({ submissionId, timezone }: { submissionId: string; timezone?: string }) {
  const query = useQuery({ queryKey: regradeKeys.attempt(submissionId), queryFn: () => regradesApi.get(submissionId), retry: false });
  const boxes = useRegradeRequestBoxes(submissionId, query, timezone);
  if (!boxes.length) return null;
  // These boxes draw inside the hand-in box's own part, so writing here is that box's work: its
  // intent bubbles to the owning page, which answers any open visit. Answering a visit again from
  // here would close the response visit this request is written in (O10).
  return <BentoVisit.Provider value={null}><Bento id={`regrade-${submissionId}`} journey="regrade" boxes={boxes} /></BentoVisit.Provider>;
}
